export default __webpack_public_path__ + "static/media/Prancheta 1.b420c44b.svg";